import { render, staticRenderFns } from "./QuoteStatistics.vue?vue&type=template&id=72c60c7e&scoped=true&"
import script from "./QuoteStatistics.vue?vue&type=script&lang=js&"
export * from "./QuoteStatistics.vue?vue&type=script&lang=js&"
import style0 from "./QuoteStatistics.vue?vue&type=style&index=0&id=72c60c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c60c7e",
  null
  
)

export default component.exports